// extracted by mini-css-extract-plugin
export default {"page":"rPGkx4Rayj4bsV4IptYx","idrow":"vlHFVT5MA48_XdOQt7qY","topbar1":"TkGqYNBukE66hotAPYmA","content":"e7HGWk2WbbMwgILbOI2Q","buttoncontainer":"u6hq5QvET0RLcbmkDbVg"};